import { useTranslation } from 'react-i18next';
import ArticleCard from '@/components/base/ArticleCard';
import { hotTopics } from '@/mocks/articles';

export default function HotTopicsGrid() {
  const { t } = useTranslation();

  return (
    <section className="bg-foreground-950 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium text-background-50 border border-background-300/30 rounded-full">
              {t('hotTopicsLabel')}
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl font-heading font-bold text-background-50">
              {t('hotTopicsTitle')}
            </h2>
          </div>
          <a
            href="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('viewAll')}
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotTopics.map((article) => (
            <ArticleCard
              key={article.id}
              slug={article.slug}
              title={article.title}
              excerpt={article.excerpt}
              category={article.category}
              categorySlug={article.categorySlug}
              imageUrl={article.imageUrl}
              date={article.date}
              viewCount={article.viewCount}
              commentCount={article.commentCount}
              isHot={article.isHot}
              isNew={article.isNew}
            />
          ))}
        </div>
      </div>
    </section>
  );
}